export default "__VITE_ASSET__ptC7jt4Q__"